import { render, staticRenderFns } from "./ResourceBorrowingTotal.vue?vue&type=template&id=f746883e&scoped=true"
import script from "./ResourceBorrowingTotal.vue?vue&type=script&lang=js"
export * from "./ResourceBorrowingTotal.vue?vue&type=script&lang=js"
import style0 from "./ResourceBorrowingTotal.vue?vue&type=style&index=0&id=f746883e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f746883e",
  null
  
)

export default component.exports